<template>
  <div class="w-full flex flex-col justify-between monitor-wrapper mx-auto" v-if="!loader || weatherInformationData[0].value != 'No Data'">
    <transition name="tray">
      <Menu v-if="$store.state.menuOpen"/>
    </transition>
    <Header :title="company + ' Monitor'" :company="company" style="height:8%;" class="bg-indigo-10"/>
    <div class="test flex-grow bg-gray-10">
      <div class="grid grid-cols-12 h-full">
        
        <div class="col-span-12 xl:col-span-5 bg-indigo-0">
          <WeatherInformation :data="weatherInformationData"/>
        </div>

        <div class="col-span-12 xl:col-span-7 flex flex-col justify-between bg-indigo-0 px-8">
          <AirQualityIndex class="bg-gray-0"  :data="airQualityIndex" />
          <div class="chart-wrapper flex w-full pb-8 pt-4">
            <DataHistoryChart class="w-full" v-if="chartData && chartData.values && chartData.values.length > 0"
            :chart-data="chartData.values" 
            :chart-labels="chartData.labels"
           :currentAqiReading="airQualityIndex.index" />
          </div>
        </div>

      </div>
    </div>
    <Footer class="bg-indigo-10"/>
  </div>
  <PageLoader v-else />
  
</template>

<script>
import Header from '@/components/generic/Header.vue'
import Footer from '@/components/generic/Footer.vue'
import PageLoader from '@/components/generic/PageLoader.vue'
import WeatherInformation from '@/components/WeatherInformation.vue'
import AirQualityIndex from '@/components/AirQualityIndex.vue'
import DataHistoryChart from '@/components/DataHistoryChart.vue'
import Menu from '@/components/generic/Menu.vue';
import moment from 'moment'

export default {
  components: {
    Header,
    Footer,
    WeatherInformation,
    AirQualityIndex,
    DataHistoryChart,
    PageLoader,
    Menu
  },
  data() {
    return {
      weatherInformationData:[
        { title: 'Temperature', value: 'No Data' },
        { title: 'Humidity', value: 'No Data' },
        { title: 'Wind Speed', value: 'No Data' },
        { title: 'Wind Direction', value: 'No Data', valueRaw: 0 },
      ],
      airQualityIndex: null,
      chartData: null,
      weatherInformationDataPrestine: null,
      airQualityIndexPrestine: null,
      chartDataPrestine: null,
      loader: false,
      company: null
    }
  },
  computed: {
    paramCompany() {
      return this.$route.params.company;
    },
  },
  watch: {
    paramCompany(n) {
      if(n) {
        this.company = n;
        this.weatherInformationData = JSON.parse(this.weatherInformationDataPrestine);
        this.airQualityIndex = JSON.stringify(this.airQualityIndexPrestine);
        this.chartData = JSON.stringify(this.chartDataPrestine);
        this.getData();
      }
    }
  },
  created() {
    this.company = this.paramCompany;
    this.checkPageAccess();
    this.weatherInformationDataPrestine = JSON.stringify(this.weatherInformationData);
    this.airQualityIndexPrestine = JSON.stringify(this.airQualityIndex);
    this.chartDataPrestine = JSON.stringify(this.chartData);
  },
  mounted() {
    this.getData();
    setInterval(() => {
      this.getData();
    }, 60000);
  },
  methods: {
    async getData() {
      this.loader = true;
      let res = await this.$store.dispatch('GET_AQI_DATA', this.company);
      this.loader = false;
      if(res)
        this.displayData(res);

      let chartData = await this.$store.dispatch('GET_CHART_DATA', this.company);
      if(chartData)
        this.chartData = chartData;
    },
    displayData(res) {
      this.buildWeatherData(res.data);
      this.airQualityIndex = this.buildAqiData(res);
    },
    buildWeatherData(data) {
      data.forEach(element => {
        switch (element.Name) {
          case 'RH':
            this.weatherInformationData[1].value = element.Value.Value + element.Value.UnitsAbbreviation;
            break;
          case 'TEMP':
            this.weatherInformationData[0].value = element.Value.Value + element.Value.UnitsAbbreviation;
            break;
          case 'WS':
            this.weatherInformationData[2].value = element.Value.Value + element.Value.UnitsAbbreviation;
            break;
          case 'WD':
            this.weatherInformationData[3].value = element.Value.Value + element.Value.UnitsAbbreviation;
            this.weatherInformationData[3].valueRaw = element.Value.Value;
            break;
        }
      });
    },
    buildAqiData(res) {
      let aqiData;
      res.data.forEach(element => {
        if (element.Name == 'AQI') {
          aqiData = {index: element.Value.Value.Value, lastUpdated: this.lastUpdatedFormatedText(res.time.date)};
        }
      });
      return aqiData;
    },
    lastUpdatedFormatedText(date) {
      return moment(date, 'YYYY-MM-DDThh:mm').format('MMMM Do YYYY, h:mm a')
    },
    checkPageAccess() {
      if(this.company == 'web-only' && !this.$store.state.userData.roles.includes('aqi_monitor_web')) {
        this.$router.push('/monitor/web');
      }
    }
  },
}
</script>

<style lang="scss">
.monitor-wrapper{
  max-width: 1840px;

  .chart-wrapper {
    .title {
      font-size: 1.6rem;
    }
  }
}
</style>
